import { render, staticRenderFns } from "./setInstall.vue?vue&type=template&id=959f0b9a&scoped=true&"
import script from "./setInstall.vue?vue&type=script&lang=js&"
export * from "./setInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959f0b9a",
  null
  
)

export default component.exports